import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "手続きインポート")
], -1)
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "手続きマスタにデータをインポートします。", -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "d-flex justify-content-center my-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("戻る")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary mx-2" }, "アップロード", -1)

import { ref, unref } from 'vue'
import { useRouter } from 'vue-router'
import { useMessenger } from '@/plugins/message'
import { useNicotto } from '@/plugins/nicotto'
import { useValidateForm } from '@/components/ui/validator'
import InputCsv from '@/components/ui/InputCsv.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportView',
  setup(__props) {

const router = useRouter()
const nicotto = useNicotto()
const messenger = useMessenger()

const formRef = ref<HTMLFormElement>()
let csv: string
const errors = ref('')
const updateCsv = (data: string) => {
  csv = data
}
const importData = async() => {
  if (! useValidateForm(unref(formRef) as HTMLFormElement).isValid()) {
    return
  }
  const importer = await nicotto.concierge.createProcessImporter(csv)
  errors.value = importer.validate().join('<br>')
  if (errors.value === '') {
    try {
      await importer.import()
      messenger.set('concierge.processes.importSucceeded')
      router.push('/concierge/processes')
    } catch (err) {
      messenger.set('concierge.processes.importFailed')
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      ref_key: "formRef",
      ref: formRef,
      onSubmit: _withModifiers(importData, ["prevent"]),
      novalidate: ""
    }, [
      _hoisted_4,
      (errors.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: errors.value,
            class: "alert alert-danger",
            role: "alert"
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true),
      _createVNode(InputCsv, {
        onChange: updateCsv,
        required: ""
      }),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/concierge/processes",
          class: "btn btn-secondary mx-2",
          role: "button"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _hoisted_8
      ])
    ], 40, _hoisted_3)
  ]))
}
}

})